import React from 'react'
import TextField from '../../text-field'
import DeleteIcon from '../../icons/delete'
import styled from 'styled-components'

const SignerListElement = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 0;
  margin: 0;
  padding-top: 0 !important;
`

const SignerItemElement = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr 1.5rem;
  gap: 0.8rem;
  width: 90%;
  align-items: center;
  justify-content: center;
`

const DeleteIconWrapperElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.isDeletable ? 1 : 0.4)};
  cursor: ${(props) => (props.isDeletable ? 'pointer' : 'not-allowed')};
`
const AddNewSignerElement = styled.h6`
  cursor: pointer;
  user-select: none;
  font-size: 0.8rem !important;
  font-weight: 200 !important;
  margin-top: 0.5rem !important;
  color: #2e8ab8;
`

function Signers({ signers, onSignersChange }) {
  const handleSignerChange = (id, attr, value) =>
    onSignersChange(
      signers.map((s) => (s.id === id ? { ...s, [attr]: value } : s))
    )

  const handleRemoveSigner = (id) =>
    onSignersChange(signers.filter((s) => s.id !== id))

  const handleAddSigner = () => {
    const lastSignerId = Math.max(...signers.map((s) => s.id))
    onSignersChange([...signers, { id: lastSignerId + 1, name: '', email: '' }])
    setTimeout(() => {
      document.getElementById(`signer-name-${lastSignerId + 1}`).focus()
    }, 100)
  }

  const isDeletable = (id) => signers.length > 1

  return (
    <>
      <SignerListElement>
        {signers.map(({ id, name, email }) => (
          <SignerItemElement key={id}>
            <TextField
              id={`signer-name-${id}`}
              placeholder="Name"
              value={name}
              onChange={(e) => handleSignerChange(id, 'name', e.target.value)}
              autocomplete="off"
            />
            <TextField
              placeholder="Email"
              value={email}
              onChange={(e) => handleSignerChange(id, 'email', e.target.value)}
              autocomplete="off"
            />
            <DeleteIconWrapperElement
              isDeletable={isDeletable(id)}
              onClick={() => isDeletable(id) && handleRemoveSigner(id)}
            >
              <DeleteIcon size="1.3rem" />
            </DeleteIconWrapperElement>
          </SignerItemElement>
        ))}
      </SignerListElement>
      <AddNewSignerElement onClick={handleAddSigner}>
        + Add signer
      </AddNewSignerElement>
    </>
  )
}

export default Signers
